import {
  AdTagCampaign,
  AdTagClassification,
  Operator,
  UrlQuery
} from "@fresh8/types/src";

const searchParams = new URLSearchParams(window.location.search);

/**
 * Returns a random operator from a list
 */
export function randomOperator(operators: Operator[]): Operator | undefined {
  const len = operators.length;
  if (!len) return;

  const rndInt = Math.floor(Math.random() * len);

  return operators[rndInt];
}

/**
 * Function that returns the campaign to be sent into the publisher's request.
 */
export function randomCampaign(
  campaigns: AdTagCampaign[],
  classification: AdTagClassification = {},
  operator: Operator
): AdTagCampaign | undefined {
  const query: UrlQuery = {};
  searchParams.forEach((value, param) => {
    query[param] = value;
  });

  // logic to filter the selectable campaigns to show
  const selectedCampaigns = campaigns.filter(c => {
    if (c.operator._id !== operator._id) return false;
    /**
     * if we have macros, all of them needs to match with those we
     * have in the queryString
     * */
    const matchingMacros =
      (c.targeting?.macros?.length || 0) === 0
        ? true
        : !!c.targeting?.macros?.find(m => query[m.key] === m.value);

    /**
     * if we have sports, all of them needs to match with those we
     * have in the adtag.classification
     * */
    const matchingTargetting =
      (c.targeting?.sport?.length || 0) === 0
        ? true
        : !!c.targeting?.sport?.find(s => {
            /**
             * if the competitors and/or competitions are empty
             * they can be respectively valid, if not, we need to check if
             * we have one of them inside the adtag.classification.competitions
             * and/or adtag.classification.competitors
             *
             * the sport is the only one we need to always compare and match
             * in this case
             * */

            const validCompetition =
              s.competition.length === 0 ||
              s.competition.find(
                c => (classification.competitions?.indexOf(c) ?? -1) > -1
              );
            const validCompetitors =
              s.competitor.length === 0 ||
              s.competitor.find(
                c => (classification.competitors?.indexOf(c) ?? -1) > -1
              );
            const validSport = s.type === classification.sport;

            return validSport && validCompetitors && validCompetition;
          });

    return matchingMacros && matchingTargetting;
  });

  const count = selectedCampaigns.length;
  if (count === 0) return;
  const idx = Math.floor(Math.random() * count);
  const selectedCampaign = selectedCampaigns[idx];

  return selectedCampaign;
}
